module.exports = __webpack_public_path__ + "img/large-v-white.39495996.png";